<template>
  <div class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-12">
          <h2 class="title is-2">Products</h2>
          <b-button type="is-primary" @click="Edit()">Add</b-button>
          <h2 class="title is-3">Active</h2>
          <b-table :data="Available">
            <b-table-column field="Name" label="Name" sortable v-slot="props">
              <span><a href="javascript://" @click="GoCheckout(props.row)">{{props.row.Name}}</a></span>
            </b-table-column>
            <b-table-column field="Price" label="Price" sortable v-slot="props">
              <span>{{props.row.Price | currency('$')}}</span>&nbsp;<span v-show="props.row.planId"><i class="fad fa-calendar-week"></i></span>
            </b-table-column>
            <b-table-column v-slot="props">
              <b-button type="is-primary" @click="Edit(props.row)">Edit</b-button>
            </b-table-column>
          </b-table>
        </div>
        <div class="column is-12">
          <h2 class="title is-3">Deleted</h2>
          <b-table :data="Unavailable">
            <b-table-column field="Name" label="Name" sortable v-slot="props">
              <span>{{props.row.Name}}</span>
            </b-table-column>
            <b-table-column field="Price" label="Price" sortable v-slot="props">
              <span>{{props.row.Price | currency('$')}}</span>&nbsp;<span v-show="props.row.planId"><i class="fad fa-calendar-week"></i></span>
            </b-table-column>
            <b-table-column v-slot="props">
              <b-button type="is-primary" @click="Edit(props.row)">Edit</b-button>
            </b-table-column>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import addProduct from '@/components/modals/addProduct.vue';
  export default {
    data() {
      return {
        products: []
      }
    },
    computed: {
      Available() {
        return this.products.filter(p => !p.deleted);
      },
      Unavailable() {
        return this.products.filter(p => p.deleted);
      }
    },
    methods: {
      Edit(product) {
        var self = this;
        this.$buefy.modal.open({
          parent: this,
          component: addProduct,
          hasModalCard: true,
          props: {
            Model: product
          },
          events: {
            saved() {
              self.Refresh();
            },
            close() {
              self.Refresh();
            }
          }
        })
      },
      Refresh() {
        this.$http.get("api/product").then(resp => {
          this.products = resp.data;
        });
      },
      GoCheckout(product) {
        this.$router.push({ name: 'checkout', params: { productId: product.Id, updatesRole: true, planId: product.planId } })
      }
    },
    created() {
      this.Refresh();
    }
  }
</script>
